import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
export const SeparatorTypeSchema = z.nativeEnum({
    SIMPLE: "simple",
    ORNAMENTAL: "ornamental",
});
export const SeparatorType = SeparatorTypeSchema.enum;
export const SeparatorSchema = BladeCommonSchema.extend({
    separatorType: z.union([z.literal(SeparatorType.SIMPLE), z.literal(SeparatorType.ORNAMENTAL)]).optional(),
});
//# sourceMappingURL=index.js.map